import React from 'react'
import MakeHomepage from '../make-homepage'

const MakeHomepageNl = () => {
    return <MakeHomepage languageCode="nl" />
}

export default MakeHomepageNl
